<template>
  <ManifestPreview
    v-if="manifest"
    :manifest="manifest"
    :fallback-accent="slide.accent"
  />
  <component v-else :is="resolved" :slide="slide" />
</template>

<script lang="ts">
import Vue, { PropType, type Component } from 'vue'
import type { SlideType, SectionKey } from '../data/slideTypeCatalog'
import type { SlidePreviewManifest } from '../lib/manifestTypes'
import { PREVIEWS } from './previews/registry'
import { MANIFESTS } from './previews/manifestRegistry'
import DefaultContent from './previews/DefaultContent.vue'
import ManifestPreview from './previews/ManifestPreview.vue'

// Per-section fallback for slides that don't yet have a dedicated preview.
const SECTION_FALLBACK: Record<SectionKey, Component> = {
  quiz: PREVIEWS['pick-answer'] || DefaultContent,
  poll: PREVIEWS.poll || DefaultContent,
  content: DefaultContent,
}

export default Vue.extend({
  name: 'SlidePreview',
  components: { ManifestPreview },
  props: {
    slide: { type: Object as PropType<SlideType>, required: true },
  },
  computed: {
    /** Manifests take precedence over Vue components when present —
     * proves the third-party path renders identically to the first-party
     * Vue components. Production would fetch this from a partner API. */
    manifest(): SlidePreviewManifest | null {
      return MANIFESTS[this.slide.id] ?? null
    },
    resolved(): Component {
      return PREVIEWS[this.slide.id] || SECTION_FALLBACK[this.slide.sectionKey]
    },
  },
})
</script>
